module.exports = __webpack_public_path__ + "img/地图.0f679051.svg";